
import { useState } from 'react';
import CompanySearch from './reviews/CompanySearch';
import CompanyReviewsList from './reviews/CompanyReviewsList';
import { useCompanyReviewsAdmin } from '@/hooks/useCompanyReviewsAdmin';
import { Review } from '@/lib/types';

const ReviewsManagement = () => {
  const [selectedCompany, setSelectedCompany] = useState<string | null>(null);
  const { 
    companyReviews, 
    setCompanyReviews, 
    isLoadingReviews, 
    loadReviewsForCompany 
  } = useCompanyReviewsAdmin();

  const handleCompanySelect = async (companyName: string) => {
    setSelectedCompany(companyName);
    await loadReviewsForCompany(companyName);
  };

  const handleReviewsChange = (updatedReviews: Review[]) => {
    setCompanyReviews(updatedReviews);
  };

  return (
    <div className="space-y-6">
      {selectedCompany ? (
        // Review list view
        <CompanyReviewsList
          companyName={selectedCompany}
          reviews={companyReviews}
          onBack={() => setSelectedCompany(null)}
          onReviewsChange={handleReviewsChange}
        />
      ) : (
        // Search view
        <CompanySearch onCompanySelect={handleCompanySelect} />
      )}
    </div>
  );
};

export default ReviewsManagement;
